import React from 'react';
import i18n from '@i18n';
import { goToHomePage } from '../../client';
import EmptyState from 'nike-ui/src/components/empty-state/EmptyState';
import { logReactError } from 'nike-ui/src/common/logging/logs';

export class ErrorBoundaryX extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.state.hasError) {
            this.setState(state => ({ ...state, hasError: false }));
        }
    }

    componentDidCatch(error, info) {
        this.setState(state => ({ ...state, hasError: true }));
        logReactError(error, info, this.props.description, this.props.level);
        console.log('Root Boundary Error', error, info);
    }

    render() {
        return this.state.hasError ? (
            <EmptyState
                text={i18n('general.error')}
                buttonText={i18n('commons.terms.hlavnaStranka')}
                buttonClassName="nui-button secondary"
                buttonOnClick={goToHomePage}
            />
        ) : (
            this.props.children
        );
    }
}
